import { render } from "./PageTemplate.vue?vue&type=template&id=36b18566&scoped=true"
import script from "./PageTemplate.vue?vue&type=script&lang=js"
export * from "./PageTemplate.vue?vue&type=script&lang=js"

import "./PageTemplate.vue?vue&type=style&index=0&id=36b18566&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b18566"]])

export default __exports__